import { z } from "zod";
import { RadioOptionsT } from "components/mui-styled-components/FormRadioGroup";

export const schema = z.object({
  utilityBillUrl: z.string().nullish(),
  utilityBillSize: z.number().nullish(),
  customSiteImage: z.string().optional(),
  customSiteImageSize: z.number().optional(),
  mounting: z.string().optional(),
  utilityCompany: z.string().optional(),
  kwhConsumption: z.string().regex(/^(?:\d+|\d{1,3}(?:,\d{3})+)?$/, {
    message: "Please enter KWH Consumption in numbers only, e.g. 1000 or 1,000",
  }),
  avgMonthlyBill: z
    .string()
    .regex(/^([0-9]+(\.[0-9]+)?)?$/, { message: "Please enter a valid dollar amount for Average Monthly Bill" }),
  hasExistingSystem: z.string().nullable(),
  // Required only when hasExistingSystem is "true"; the drawer enforces that in its
  // qualification check rather than here, so a partially filled form can still be saved.
  existingSystemOwnership: z.string().nullable(),
  isNewConstruction: z
    .boolean()
    .or(z.union([z.literal("false"), z.literal("true")]))
    .nullable(),
  detailsOfConstruction: z.string().nullable(),
  estimatedDateTo: z.string().nullable(),
});

export type SiteInfoFormT = z.infer<typeof schema>;

export const blankFormData = {
  utilityBillUrl: "",
  utilityBillSize: 0,
  customSiteImage: "",
  customSiteImageSize: 0,
  mounting: "roof",
  utilityCompany: "",
  kwhConsumption: "",
  avgMonthlyBill: "",
  hasExistingSystem: null,
  existingSystemOwnership: null,
  isNewConstruction: null,
  detailsOfConstruction: null,
  estimatedDateTo: null,
};

export const yesOrNoOptions: RadioOptionsT = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
